"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplaySubject = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Subject2 = require("./Subject");

var _queue = require("./scheduler/queue");

var _Subscription = require("./Subscription");

var _observeOn = require("./operators/observeOn");

var _ObjectUnsubscribedError = require("./util/ObjectUnsubscribedError");

var _SubjectSubscription = require("./SubjectSubscription");

/**
 * @class ReplaySubject<T>
 */
var ReplaySubject =
/*#__PURE__*/
function (_Subject) {
  (0, _inherits2.default)(ReplaySubject, _Subject);

  function ReplaySubject() {
    var _this;

    var bufferSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.POSITIVE_INFINITY;
    var windowTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
    var scheduler = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2.default)(this, ReplaySubject);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReplaySubject).call(this));
    _this.scheduler = scheduler;
    _this._events = [];
    _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
    _this._windowTime = windowTime < 1 ? 1 : windowTime;
    return _this;
  }

  (0, _createClass2.default)(ReplaySubject, [{
    key: "next",
    value: function next(value) {
      var now = this._getNow();

      this._events.push(new ReplayEvent(now, value));

      this._trimBufferThenGetEvents();

      (0, _get2.default)((0, _getPrototypeOf2.default)(ReplaySubject.prototype), "next", this).call(this, value);
    }
  }, {
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var _events = this._trimBufferThenGetEvents();

      var scheduler = this.scheduler;
      var subscription;

      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      } else if (this.hasError) {
        subscription = _Subscription.Subscription.EMPTY;
      } else if (this.isStopped) {
        subscription = _Subscription.Subscription.EMPTY;
      } else {
        this.observers.push(subscriber);
        subscription = new _SubjectSubscription.SubjectSubscription(this, subscriber);
      }

      if (scheduler) {
        subscriber.add(subscriber = new _observeOn.ObserveOnSubscriber(subscriber, scheduler));
      }

      var len = _events.length;

      for (var i = 0; i < len && !subscriber.closed; i++) {
        subscriber.next(_events[i].value);
      }

      if (this.hasError) {
        subscriber.error(this.thrownError);
      } else if (this.isStopped) {
        subscriber.complete();
      }

      return subscription;
    }
  }, {
    key: "_getNow",
    value: function _getNow() {
      return (this.scheduler || _queue.queue).now();
    }
  }, {
    key: "_trimBufferThenGetEvents",
    value: function _trimBufferThenGetEvents() {
      var now = this._getNow();

      var _bufferSize = this._bufferSize;
      var _windowTime = this._windowTime;
      var _events = this._events;
      var eventsCount = _events.length;
      var spliceCount = 0; // Trim events that fall out of the time window.
      // Start at the front of the list. Break early once
      // we encounter an event that falls within the window.

      while (spliceCount < eventsCount) {
        if (now - _events[spliceCount].time < _windowTime) {
          break;
        }

        spliceCount++;
      }

      if (eventsCount > _bufferSize) {
        spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
      }

      if (spliceCount > 0) {
        _events.splice(0, spliceCount);
      }

      return _events;
    }
  }]);
  return ReplaySubject;
}(_Subject2.Subject);

exports.ReplaySubject = ReplaySubject;

var ReplayEvent = function ReplayEvent(time, value) {
  (0, _classCallCheck2.default)(this, ReplayEvent);
  this.time = time;
  this.value = value;
};